module.exports = __webpack_public_path__ + "app/principal/principal-offreApi-3u7inTlG.html";